import { client } from "braintree-web";

/*
 Stripe Payment Request
*/
class StripePaymentRequest {

    stripe: any;
    paymentRequest: any;
    config: any;
    currentAmount: Function;
    readCookie: Function;
    isBlank: Function;
    ready: Function;
    isOrderFulfilled: Function;

    constructor(config: any, key: String, getPayAmount: Function, readCookie: Function, isOrderFulfilled: Function) {
        
        if (config.general.stripeConnectId && config.general.stripeConnectId.trim()) {
            this.stripe = (<any>window).Stripe(key,
                {
                    stripeAccount: config.general.stripeConnectId,
                    apiVersion: "2020-08-27"
                }) as any;
        } else {
            this.stripe = (<any>window).Stripe(key,
                {
                    apiVersion: "2020-08-27"
                }) as any; // Get stripe from Global window.
        }
        
        this.config = config;
        this.currentAmount = () => {
            return getPayAmount();
        }
        this.createPaymentRequest();
        this.createElements();
        this.setupChangeListener();
        this.readCookie = readCookie;
        this.isBlank = (str) => {
            return (!str || /^\s*$/.test(str));
        }
        this.isOrderFulfilled = isOrderFulfilled;
    }

    createPaymentRequest() {
        const { isoCurrencySymbol, goalType, isSubscription, companyName, planName, isGift } = this.config.general;

        let requestConfig = {
            requestShipping: false,
            country: 'GB',
            currency: `${isoCurrencySymbol.toLowerCase()}`,
            total: {
                amount: this.currentAmount().unitValue,
                label: (isSubscription) ? `${goalType} ${planName}` : `${goalType} ${companyName}`,
            },
            requestPayerEmail: true,
            requestPayerName: true,
        };

        this.paymentRequest = this.stripe.paymentRequest(requestConfig);
    }

    createElements() {

        const elements: any = this.stripe.elements();
        const { goalType } = this.config.general;

        const prButton: any = elements.create('paymentRequestButton', {
            paymentRequest: this.paymentRequest,
            style: {
                paymentRequestButton: {
                    type: goalType === "DONATION" ? "donate" : "default",
                    theme: 'dark',
                    height: '50px'
                }
            }
        });

        this.paymentRequest.canMakePayment().then((result) => {
            console.log("can make payment: ", result);
            if (result) {
                prButton.mount('#payment-request-button');
            } else {
                document.getElementById('payment-request-button').style.display = 'none';
            }
        });

        this.paymentRequest.on('paymentmethod', (ev) => this.paymentRequestHandler(ev));
    }

    async paymentRequestHandler(ev) {

        const { demoMode, isoCurrencySymbol, interactionId, version, goalTypeInt, planID, paymentDescription, companyId, isSubscription, meta, stripeRedirectUrl } = this.config.general;

        let createCustomerRequest: object = {
            companyId: this.config.general.companyId,
            demo: this.config.general.demoMode,
            email: ev.payerEmail,
            fullName: ev.payerName,
            addressLine1: ev.paymentMethod.billing_details.address.line1,
            addressLine2: ev.paymentMethod.billing_details.address.line2,
            city: ev.paymentMethod.billing_details.address.city,
            state: ev.paymentMethod.billing_details.address.state,
            postcode: ev.paymentMethod.billing_details.address.postal_code,
            country: ev.paymentMethod.billing_details.address.country
        };

        const emailResponse = await fetch("/Stripe/GetOrCreateCustomer", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(createCustomerRequest),
        });

        const { customerId } = await emailResponse.json();

        // Fetch the payment intent
        let createPaymentIntentRequest: object = {
            demo: demoMode,
            currencyCode: isoCurrencySymbol.toLowerCase(),
            amount: this.currentAmount().unitValue,
            interactionId: interactionId,
            goalType: goalTypeInt,
            version: version,
            description: paymentDescription,
            companyId: companyId,
            customerId: customerId,
            meta: meta,
            isSubscription: isSubscription,
            subscriptionPlanId: planID,
            walletName: ev.walletName
        };

        const response = await fetch("/Stripe/CreatePaymentIntent", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(createPaymentIntentRequest),
        });

        const { clientSecretKey, paymentIntentId } = await response.json();
        let returnUrl = `${stripeRedirectUrl}&donationAmount=${this.currentAmount().value}&email=${ev.payerEmail}`;

        // Confirm the PaymentIntent without handling potential next actions (yet).
        this.stripe.confirmCardPayment(
            clientSecretKey,
            { payment_method: ev.paymentMethod.id, return_url: returnUrl},
            { handleActions: false }
        ).then(function (confirmResult) {
            if (confirmResult.error) {
                // Report to the browser that the payment failed, prompting it to
                // re-show the payment interface, or show an error message and close
                // the payment interface.
                ev.complete('fail');
            } else {
                // Report to the browser that the confirmation was successful, prompting
                // it to close the browser payment method collection interface.
                ev.complete('success');
                window.location.href = returnUrl; // Send to RedirectUrl
                // Check if the PaymentIntent requires any actions and if so let Stripe.js
                // handle the flow. If using an API version older than "2019-02-11"
                // instead check for: `paymentIntent.status === "requires_source_action"`.
                if (confirmResult.paymentIntent.status === "requires_action") {
                    // Let Stripe.js handle the rest of the payment flow.
                    this.stripe.confirmCardPayment(clientSecretKey).then(function (result) {
                        if (result.error) {
                            // The payment failed -- ask your customer for a new payment method.
                        } else {
                            // The payment has succeeded.
                            window.location.href = returnUrl; // Send to RedirectUrl
                        }
                    });
                } else {
                    // The payment has succeeded.
                    window.location.href = returnUrl; // Send to RedirectUrl
                }
            }
        });
    };

    setupChangeListener() {
        let editableValue: Element = document.querySelector('.editableH1');

        const { goalType, planName, companyName, isSubscription } = this.config.general;

        editableValue.addEventListener('change', (e) => {

            this.paymentRequest.update({
                total: {
                    amount: this.currentAmount().unitValue,
                    label: (isSubscription) ? `${goalType} ${planName}` : `${goalType} ${companyName}`
                }
            });
        });
    }
}

export default StripePaymentRequest;
